const useSignaturePad = () => {
  let canvas: HTMLCanvasElement
  let context: CanvasRenderingContext2D
  let paint: boolean
  let clickX: number[] = []
  let clickY: number[] = []
  let clickDrag: boolean[] = []
  let signName = ''
  let companyName = ''
  let isActive = false
  let updateActivePad
  const scale = window.devicePixelRatio || 1

  const init = (
    id: string,
    updateActive: (target: boolean) => void,
    name?: string,
    company?: string
  ) => {
    canvas = document.getElementById(id) as HTMLCanvasElement
    canvas.width = Math.floor(canvas.offsetWidth * scale)
    canvas.height = Math.floor(canvas.offsetHeight * scale)
    context = canvas.getContext('2d') as CanvasRenderingContext2D

    context.lineCap = 'round'
    context.lineJoin = 'round'
    context.strokeStyle = 'black'
    context.lineWidth = 3
    context.scale(scale, scale)
    signName = name || ''
    companyName = company || ''

    updateActivePad = updateActive
    isActive = false
    updateActivePad(false)

    setPlaceHolder()
    createUserEvents()
  }

  const createUserEvents = () => {
    canvas.addEventListener('mousedown', pressEventHandler)
    canvas.addEventListener('mousemove', dragEventHandler)
    canvas.addEventListener('mouseup', releaseEventHandler)
    canvas.addEventListener('mouseout', cancelEventHandler)

    canvas.addEventListener('touchstart', pressEventHandler)
    canvas.addEventListener('touchmove', dragEventHandler)
    canvas.addEventListener('touchend', releaseEventHandler)
    canvas.addEventListener('touchcancel', cancelEventHandler)
  }

  const pressEventHandler = (e: MouseEvent | TouchEvent) => {
    isActive = true
    updateActivePad(true)
    let mouseX = (e as TouchEvent).changedTouches ?
      (e as TouchEvent).changedTouches[0].pageX :
      (e as MouseEvent).pageX

    let mouseY = (e as TouchEvent).changedTouches ?
      (e as TouchEvent).changedTouches[0].pageY :
      (e as MouseEvent).pageY
    mouseX -= canvas.getBoundingClientRect().left
    mouseY -= canvas.getBoundingClientRect().top

    paint = true
    addPosition(mouseX, mouseY, false)
    redraw()
  }

  const dragEventHandler = (e: MouseEvent | TouchEvent) => {
    let mouseX = (e as TouchEvent).changedTouches ?
      (e as TouchEvent).changedTouches[0].pageX :
      (e as MouseEvent).pageX
    let mouseY = (e as TouchEvent).changedTouches ?
      (e as TouchEvent).changedTouches[0].pageY :
      (e as MouseEvent).pageY
    mouseX -= canvas.getBoundingClientRect().left
    mouseY -= canvas.getBoundingClientRect().top

    if(paint) {
      addPosition(mouseX, mouseY, true)
      redraw()
    }

    e.preventDefault()
  }
  const releaseEventHandler = () => {
    isActive = true
    updateActivePad(true)
    paint = false
    redraw()
  }
  const cancelEventHandler = () => {
    paint = false
  }

  const addPosition = (x: number, y: number, dragging: boolean) => {
    clickX.push(x)
    clickY.push(y)
    clickDrag.push(dragging)
  }

  const clearCanvas = () => {
    isActive = false
    updateActivePad(false)
    context.clearRect(0, 0, canvas.width, canvas.height)
    clickX = []
    clickY = []
    clickDrag = []
    setPlaceHolder()
  }

  const drawWithoutPlaceHolder = () => {
    context.clearRect(0, 0, canvas.width, canvas.height)
    redraw()
  }

  const setPlaceHolder = () => {
    const positionX = Math.floor(canvas.offsetWidth/2)

    context.font = '12px Spoqa Han Sans Neo'
    context.fillStyle = '#7B90FF'
    const infoText = '이름으로 서명해주세요.'
    context.textAlign = 'center'
    context.fillText(infoText, positionX, 30, canvas.offsetWidth)

    context.font = '18px Spoqa Han Sans Neo'
    context.fillStyle = '#D7D8DB'
    const companyText = companyName ? `${companyName} 대표` : '회사대표'
    context.textAlign = 'center'
    context.fillText(companyText, positionX, 80, canvas.offsetWidth)

    context.font = '40px Spoqa Han Sans Neo'
    context.fillStyle = '#D7D8DB'
    const nameText = signName || '여기에 서명해주세요.'
    context.textAlign = 'center'
    context.fillText(nameText, positionX, 130, canvas.offsetWidth)


  }
 
  const redraw = () => {
    for(let i = 0; i < clickX.length; i=i+1) {
      context.beginPath()
      if(clickDrag[i] && i) {
        context.moveTo(clickX[i - 1], clickY[i - 1])
      } else {
        context.moveTo(clickX[i] - 1, clickY[i])
      }

      context.lineTo(clickX[i], clickY[i])
      context.stroke()
    }
    context.closePath()
  }

  const exportToImage = () => {
    drawWithoutPlaceHolder()
    const dataUrl = canvas.toDataURL('image/png')
    const blobBin = atob(dataUrl.split(',')[1])
    const array: number[] = []
    for(let i = 0; i < blobBin.length; i=i+1) {
      array.push(blobBin.charCodeAt(i))
    }
    const file = new File([new Uint8Array(array)], 'signature.png', {type: 'image/png'})

    return file
  }

  const getIsActive = () => {
    return isActive
  }

  return {
    init,
    clearCanvas,
    exportToImage,
    getIsActive,
  }
}

export default useSignaturePad()
